import { render, staticRenderFns } from "./ChatterStatusTable.vue?vue&type=template&id=ca7104b0&scoped=true"
import script from "./ChatterStatusTable.vue?vue&type=script&lang=js"
export * from "./ChatterStatusTable.vue?vue&type=script&lang=js"
import style0 from "./ChatterStatusTable.vue?vue&type=style&index=0&id=ca7104b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7104b0",
  null
  
)

export default component.exports